/* eslint-disable max-len, @cspell/spellchecker */
export const DEFAULT_CLIENT_CONFIG = {
  clientConfig: {
    measurements: [
      {
        name: 'glucose',
        metric: {
          units: 'mmol/L',
          precision: 1,
          minThreshold: null,
          maxThreshold: null,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'mg/dL',
          precision: 0,
          minThreshold: null,
          maxThreshold: null,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'blood_glucose',
        metric: {
          units: 'mmol/L',
          precision: 1,
          minThreshold: 1.0,
          maxThreshold: 50.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'mg/dL',
          precision: 0,
          minThreshold: 18.0,
          maxThreshold: 900.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'blood_ketones',
        metric: {
          units: 'mmol/L',
          precision: 1,
          minThreshold: 0.0,
          maxThreshold: 30.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'mmol/L',
          precision: 1,
          minThreshold: 0.0,
          maxThreshold: 30.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'breath_ketones',
        metric: {
          units: 'aces',
          precision: 0,
          minThreshold: 0.0,
          maxThreshold: 50.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'aces',
          precision: 0,
          minThreshold: 0.0,
          maxThreshold: 50.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'blood_pressure',
        metric: {
          units: 'mmHg',
          precision: 0,
          minThreshold: 20.0,
          maxThreshold: 300.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'mmHg',
          precision: 0,
          minThreshold: 20.0,
          maxThreshold: 300.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'body_fat_percentage',
        metric: {
          units: 'percent',
          precision: 1,
          minThreshold: 1.0,
          maxThreshold: 70.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'percent',
          precision: 1,
          minThreshold: 1.0,
          maxThreshold: 70.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'body_temperature',
        metric: {
          units: '°C',
          precision: 1,
          minThreshold: 30.0,
          maxThreshold: 50.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: '°F',
          precision: 1,
          minThreshold: 86.0,
          maxThreshold: 122.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'step_count',
        metric: {
          units: 'steps',
          precision: 0,
          minThreshold: 1.0,
          maxThreshold: 200000.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'steps',
          precision: 0,
          minThreshold: 1.0,
          maxThreshold: 200000.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'flights_climbed',
        metric: {
          units: 'flights',
          precision: 0,
          minThreshold: 1.0,
          maxThreshold: 200000.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'flights',
          precision: 0,
          minThreshold: 1.0,
          maxThreshold: 200000.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'exercise_time',
        metric: {
          units: 'minutes',
          precision: 0,
          minThreshold: 0.1,
          maxThreshold: 1400.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'minutes',
          precision: 0,
          minThreshold: 0.1,
          maxThreshold: 1400.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'cycling_distance',
        metric: {
          units: 'km',
          precision: 1,
          minThreshold: 0.01,
          maxThreshold: 1000.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'miles',
          precision: 1,
          minThreshold: 0.006,
          maxThreshold: 621.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'running_distance',
        metric: {
          units: 'km',
          precision: 1,
          minThreshold: 0.01,
          maxThreshold: 1000.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'miles',
          precision: 1,
          minThreshold: 0.006,
          maxThreshold: 621.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'swimming_distance',
        metric: {
          units: 'km',
          precision: 1,
          minThreshold: null,
          maxThreshold: null,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'miles',
          precision: 1,
          minThreshold: null,
          maxThreshold: null,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'weight',
        metric: {
          units: 'kilos',
          precision: 1,
          minThreshold: 10.0,
          maxThreshold: 370.0,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'pounds',
          precision: 1,
          minThreshold: 22.0,
          maxThreshold: 800.0,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
      {
        name: 'stress',
        metric: {
          units: 'stress',
          precision: 1,
          minThreshold: null,
          maxThreshold: null,
          __typename: 'MeasurementConfigUnit',
        },
        imperial: {
          units: 'stress',
          precision: 1,
          minThreshold: null,
          maxThreshold: null,
          __typename: 'MeasurementConfigUnit',
        },
        __typename: 'MeasurementConfig',
      },
    ],
    activityTypes: ['Exercise', 'Fasting', 'Meditation', 'Sleep'],
    mealTypes: ['Breakfast', 'Lunch', 'Dinner', 'Snack', 'Dessert', 'Drink', 'Supplement'],
    dayTabs: [
      { key: '0', value: 'Cal', __typename: 'KeyValuePairString' },
      { key: '7', value: '7 days', __typename: 'KeyValuePairString' },
      { key: '14', value: '14 days', __typename: 'KeyValuePairString' },
      { key: '30', value: '30 days', __typename: 'KeyValuePairString' },
      { key: '60', value: '60 days', __typename: 'KeyValuePairString' },
      { key: '120', value: '120 days', __typename: 'KeyValuePairString' },
    ],
    timeZones: [
      'Pacific/Honolulu',
      'America/Juneau',
      'America/Los_Angeles',
      'America/Denver',
      'America/Chicago',
      'America/New_York',
      'America/Halifax',
      'America/Argentina/Buenos_Aires',
      'Europe/London',
      'Europe/Paris',
      'Africa/Cairo',
      'Europe/Moscow',
      'Asia/Karachi',
      'Asia/Kolkata',
      'Asia/Bangkok',
      'Asia/Hong_Kong',
      'Asia/Tokyo',
      'Australia/Sydney',
      'Pacific/Auckland',
      'Pacific/Apia',
    ],
    events: {
      filters: {
        types: [
          {
            key: 'meals',
            value: [
              'favorite',
              'breakfast',
              'lunch',
              'dinner',
              'dessert',
              'drink',
              'snack',
              'supplement',
              'unknown',
            ],
            __typename: 'KeyValuePairStringArray',
          },
          {
            key: 'activities',
            value: ['favorite', 'sleep', 'fasting', 'exercise', 'meditation'],
            __typename: 'KeyValuePairStringArray',
          },
          {
            key: 'measurements',
            value: [
              'weight',
              'step_count',
              'blood_glucose',
              'blood_ketones',
              'breath_ketones',
              'blood_pressure',
              'exercise_time',
              'flights_climbed',
              'body_temperature',
              'cycling_distance',
              'running_distance',
              'swimming_distance',
            ],
            __typename: 'KeyValuePairStringArray',
          },
          {
            key: 'journal',
            value: ['my_entries', 'coach_entries'],
            __typename: 'KeyValuePairStringArray',
          },
        ],
        orderBy: ['occurred_at', 'score', 'peak', 'exposure', 'stability', 'recovery'],
        order: ['descending', 'ascending'],
        __typename: 'EventsFilters',
      },
      __typename: 'Events',
    },
    meals: {
      filters: {
        types: [
          'favorite',
          'breakfast',
          'lunch',
          'dinner',
          'dessert',
          'drink',
          'snack',
          'supplement',
          'unknown',
        ],
        orderBy: ['occurred_at', 'score', 'peak', 'exposure', 'stability', 'recovery'],
        order: ['descending', 'ascending'],
        __typename: 'ListFilters',
      },
      __typename: 'Meals',
    },
    insights: {
      statistics: [
        {
          name: 'daily_average',
          metric: {
            ranges: [
              { from: 80.0, to: 100.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 50.0, to: 79.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 1.0, to: 49.0, type: 'bounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'decimal',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 80.0, to: 100.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 50.0, to: 79.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 1.0, to: 49.0, type: 'bounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'decimal',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'meals_average',
          metric: {
            ranges: [
              { from: 80.0, to: 100.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 50.0, to: 79.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 1.0, to: 49.0, type: 'bounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'decimal',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 80.0, to: 100.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 50.0, to: 79.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 1.0, to: 49.0, type: 'bounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'decimal',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'time_within_range',
          metric: {
            ranges: [
              { from: 95.0, to: 100.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 85.0, to: 94.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 1.0, to: 84.0, type: 'bounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'percentage',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 95.0, to: 100.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 85.0, to: 94.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 1.0, to: 84.0, type: 'bounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'percentage',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'standard_deviation',
          metric: {
            ranges: [
              { from: null, to: 0.8, type: 'unbounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 0.9, to: 1.1, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 1.2, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 1,
            units: 'decimal',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: null, to: 14.0, type: 'unbounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 15.0, to: 20.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 21.0, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'decimal',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'mean',
          metric: {
            ranges: [
              { from: 3.9, to: 5.8, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 5.9, to: 6.4, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 3.1, to: 3.8, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 6.5, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: null, to: 3.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 1,
            units: 'mmol/L',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 70.0, to: 105.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 106.0, to: 115.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 55.0, to: 69.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 116.0, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: null, to: 54.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'mg/dL',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'min',
          metric: {
            ranges: [
              { from: 3.9, to: 7.8, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 3.1, to: 3.8, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 7.8, to: 8.8, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: null, to: 3.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: 8.9, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 1,
            units: 'mmol/L',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 70.0, to: 140.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 55.0, to: 69.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 141.0, to: 159.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: null, to: 54.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: 160.0, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'mg/dL',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'max',
          metric: {
            ranges: [
              { from: 3.9, to: 7.8, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 3.1, to: 3.8, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 7.8, to: 8.8, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: null, to: 3.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: 8.9, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 1,
            units: 'mmol/L',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 70.0, to: 140.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 55.0, to: 69.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 141.0, to: 159.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: null, to: 54.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: 160.0, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'mg/dL',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'sleep_average',
          metric: {
            ranges: [
              { from: 3.9, to: 5.8, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 5.9, to: 6.4, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 3.1, to: 3.8, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 6.5, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: null, to: 3.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 1,
            units: 'mmol/L',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 70.0, to: 105.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 106.0, to: 115.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 55.0, to: 69.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 116.0, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: null, to: 54.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'mg/dL',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'morning_average',
          metric: {
            ranges: [
              { from: 3.9, to: 5.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 5.1, to: 5.6, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 3.1, to: 3.8, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 5.7, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: null, to: 3.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 1,
            units: 'mmol/L',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 70.0, to: 90.0, type: 'unbounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 91.0, to: 100.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 55.0, to: 69.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 101.0, to: null, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
              { from: null, to: 54.0, type: 'unbounded', rating: 'bad', __typename: 'RangeUnit' },
            ],
            precision: 0,
            units: 'mg/dL',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
        {
          name: 'ketones_max',
          metric: {
            ranges: [
              { from: 0.5, to: 3.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 3.1, to: 8.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 8.1, to: 10.0, type: 'bounded', rating: 'bad', __typename: 'RangeUnit' },
              {
                from: 10.1,
                to: null,
                type: 'unbounded',
                rating: 'critical',
                __typename: 'RangeUnit',
              },
            ],
            precision: 1,
            units: 'mmol/L',
            __typename: 'ConfigUnit',
          },
          imperial: {
            ranges: [
              { from: 0.5, to: 3.0, type: 'bounded', rating: 'good', __typename: 'RangeUnit' },
              { from: 3.1, to: 8.0, type: 'bounded', rating: 'ok', __typename: 'RangeUnit' },
              { from: 8.1, to: 10.0, type: 'bounded', rating: 'bad', __typename: 'RangeUnit' },
              {
                from: 10.1,
                to: null,
                type: 'unbounded',
                rating: 'critical',
                __typename: 'RangeUnit',
              },
            ],
            precision: 1,
            units: 'mmol/L',
            __typename: 'ConfigUnit',
          },
          __typename: 'Statistics',
        },
      ],
      __typename: 'Config',
    },
    biteAi: {
      units: [
        { key: 'calories', value: 'kcal', __typename: 'BiteAiKeyValuePairString' },
        { key: 'totalFat', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'saturatedFat', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'monounsaturatedFat', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'polyunsaturatedFat', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'transFat', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'totalCarb', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'sugars', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fiber', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'protein', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'cholesterol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'sodium', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'potassium', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'calcium', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'iron', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'magnesium', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'phosphorus', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'zinc', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'copper', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'manganese', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'selenium', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminARae', value: 'mcg rae', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminAIu', value: 'IU', __typename: 'BiteAiKeyValuePairString' },
        { key: 'retinol', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'alphaCarotene', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'betaCarotene', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'betaCryptoxanthin', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'lycopene', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'thiamin', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'riboflavin', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'niacin', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'pantothenicAcid', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminB6', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'folate', value: 'mcg dfe', __typename: 'BiteAiKeyValuePairString' },
        { key: 'folicAcid', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminB12', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'choline', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminC', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminD', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminE', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminK', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'water', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'ash', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'caffeine', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'alcohol', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'addedSugars', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'omega3', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'omega6', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'theobromine', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'luteinZeaxanthin', value: 'mcg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fruit', value: 'servings', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vegetable', value: 'servings', __typename: 'BiteAiKeyValuePairString' },
        { key: 'wholeGrain', value: 'servings', __typename: 'BiteAiKeyValuePairString' },
        { key: 'starch', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'sucrose', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'glucose', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fructose', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'lactose', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'maltose', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'adjustedProtein', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'energyKj', value: 'kJ', __typename: 'BiteAiKeyValuePairString' },
        { key: 'galactose', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fluoride', value: 'µg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminDIu', value: 'IU', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminD2', value: 'µg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'vitaminD3', value: 'µg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'betaTocopherol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'gammaTocopherol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'deltaTocopherol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'alphaTocotrienol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'betaTocotrienol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'gammaTocotrienol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'deltaTocotrienol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'totalFolate', value: 'µg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'menaquinone4', value: 'µg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'dihydrophylloquinone', value: 'µg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'folateFood', value: 'µg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'betaine', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'tryptophan', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'threonine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'isoleucine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'leucine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'lysine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'methionine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'cystine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'phenylalanine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'tyrosine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'valine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'arginine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'histidine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'alanine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'asparticAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'glutamicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'glycine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'proline', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'serine', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'hydroxyproline', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'addedVitaminE', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'addedVitaminB12', value: 'µg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'butyricAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'caproicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'caprylicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'capricAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'lauricAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'myristic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'palmitic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'stearic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'arachidic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'oleic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'linoleic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'linolenic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid204', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'docosahexaenoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'behenic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'myristoleic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'palmitoleic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'parinaricAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'gadoleic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'eicosapentaenoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'docosenoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'docosapentaenoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'phytosterols', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'stigmasterol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'campesterol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'betaSitosterol', value: 'mg', __typename: 'BiteAiKeyValuePairString' },
        { key: 'pentadecanoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'margaric', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'lignoceric', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid161T', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid181T', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid221T', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid182TNfd', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid182I', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid182Tt', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid182Clas', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'nervonic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'eicosadienoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid161C', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid181C', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid182N6Cc', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'erucicCitoleic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'gammaLinolenicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'heptadecenoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'eicosatrienoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'transFatMonoenoic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'transFatPolyenoic', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'tridecanoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'pentadecenoicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'alphaLinolenicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid203N3', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid203N6', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'arachidonicAcid', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid183i', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid215', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid224', value: 'g', __typename: 'BiteAiKeyValuePairString' },
        { key: 'fattyAcid18111T', value: 'g', __typename: 'BiteAiKeyValuePairString' },
      ],
      dailyValues: [
        { key: 'calories', value: 2000.0, __typename: 'KeyValuePairFloat' },
        { key: 'total_fat', value: 78.0, __typename: 'KeyValuePairFloat' },
        { key: 'saturated_fat', value: 20.0, __typename: 'KeyValuePairFloat' },
        { key: 'monounsaturated_fat', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'polyunsaturated_fat', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'trans_fat', value: 2.0, __typename: 'KeyValuePairFloat' },
        { key: 'total_carb', value: 275.0, __typename: 'KeyValuePairFloat' },
        { key: 'sugars', value: 50.0, __typename: 'KeyValuePairFloat' },
        { key: 'fiber', value: 28.0, __typename: 'KeyValuePairFloat' },
        { key: 'protein', value: 50.0, __typename: 'KeyValuePairFloat' },
        { key: 'cholesterol', value: 300.0, __typename: 'KeyValuePairFloat' },
        { key: 'sodium', value: 2400.0, __typename: 'KeyValuePairFloat' },
        { key: 'potassium', value: 4700.0, __typename: 'KeyValuePairFloat' },
        { key: 'calcium', value: 1300.0, __typename: 'KeyValuePairFloat' },
        { key: 'iron', value: 18.0, __typename: 'KeyValuePairFloat' },
        { key: 'magnesium', value: 420.0, __typename: 'KeyValuePairFloat' },
        { key: 'phosphorus', value: 1250.0, __typename: 'KeyValuePairFloat' },
        { key: 'zinc', value: 11.0, __typename: 'KeyValuePairFloat' },
        { key: 'copper', value: 0.9, __typename: 'KeyValuePairFloat' },
        { key: 'manganese', value: 2.3, __typename: 'KeyValuePairFloat' },
        { key: 'selenium', value: 55.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_a_rae', value: 900.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_a_iu', value: 3000.0, __typename: 'KeyValuePairFloat' },
        { key: 'retinol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'alpha_carotene', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'beta_carotene', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'beta_cryptoxanthin', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'lycopene', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'thiamin', value: 1.2, __typename: 'KeyValuePairFloat' },
        { key: 'riboflavin', value: 1.3, __typename: 'KeyValuePairFloat' },
        { key: 'niacin', value: 16.0, __typename: 'KeyValuePairFloat' },
        { key: 'pantothenic_acid', value: 5.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_b6', value: 1.7, __typename: 'KeyValuePairFloat' },
        { key: 'folate', value: 400.0, __typename: 'KeyValuePairFloat' },
        { key: 'folic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_b12', value: 2.4, __typename: 'KeyValuePairFloat' },
        { key: 'choline', value: 550.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_c', value: 90.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_d', value: 20.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_e', value: 15.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_k', value: 120.0, __typename: 'KeyValuePairFloat' },
        { key: 'water', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'ash', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'caffeine', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'alcohol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'added_sugars', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'omega_3', value: 1.6, __typename: 'KeyValuePairFloat' },
        { key: 'omega_6', value: 14.0, __typename: 'KeyValuePairFloat' },
        { key: 'theobromine', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'lutein_zeaxanthin', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fruit', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'vegetable', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'whole_grain', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'starch', value: 4.4, __typename: 'KeyValuePairFloat' },
        { key: 'sucrose', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'glucose', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fructose', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'lactose', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'maltose', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'adjusted_protein', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'energy_kj', value: 8368.0, __typename: 'KeyValuePairFloat' },
        { key: 'galactose', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fluoride', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_d_iu', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_d2', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'vitamin_d3', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'beta_tocopherol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'gamma_tocopherol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'delta_tocopherol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'alpha_tocotrienol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'beta_tocotrienol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'gamma_tocotrienol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'delta_tocotrienol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'total_folate', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'menaquinone_4', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'dihydrophylloquinone', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'folate_food', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'betaine', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'tryptophan', value: 0.28, __typename: 'KeyValuePairFloat' },
        { key: 'threonine', value: 1.05, __typename: 'KeyValuePairFloat' },
        { key: 'isoleucine', value: 1.4, __typename: 'KeyValuePairFloat' },
        { key: 'leucine', value: 2.73, __typename: 'KeyValuePairFloat' },
        { key: 'lysine', value: 2.1, __typename: 'KeyValuePairFloat' },
        { key: 'methionine', value: 0.728, __typename: 'KeyValuePairFloat' },
        { key: 'cystine', value: 0.287, __typename: 'KeyValuePairFloat' },
        { key: 'phenylalanine', value: 0.875, __typename: 'KeyValuePairFloat' },
        { key: 'tyrosine', value: 0.875, __typename: 'KeyValuePairFloat' },
        { key: 'valine', value: 1.82, __typename: 'KeyValuePairFloat' },
        { key: 'arginine', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'histidine', value: 0.7, __typename: 'KeyValuePairFloat' },
        { key: 'alanine', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'aspartic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: '0lutamic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: '0lycine', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'proline', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'serine', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'hydroxyproline', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'added_vitamin_e', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'added_vitamin_b12', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'butyric_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'caproic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'caprylic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'capric_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'lauric_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'myristic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'palmitic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'stearic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'arachidic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'oleic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'linoleic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'linolenic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_20_4', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'docosahexaenoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'behenic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'myristoleic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'palmitoleic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'parinaric_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: '0adoleic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'eicosapentaenoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'docosenoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'docosapentaenoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'phytosterols', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'sti0masterol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'campesterol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'beta_sitosterol', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'pentadecanoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'mar0aric', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'li0noceric', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_16_1_t', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_1_t', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_22_1_t', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_2_t_nfd', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_2_i', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_2_tt', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_2_clas', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'nervonic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'eicosadienoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_16_1_c', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_1_c', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_2_n_6_cc', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'erucic_citoleic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: '0amma_linolenic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'heptadecenoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'eicosatrienoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'trans_fat_monoenoic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'trans_fat_polyenoic', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'tridecanoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'pentadecenoic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'alpha_linolenic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_20_3_n_3', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_20_3_n_6', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'arachidonic_acid', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_3i', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_21_5', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_22_4', value: 0.0, __typename: 'KeyValuePairFloat' },
        { key: 'fatty_acid_18_1_11_t', value: 0.0, __typename: 'KeyValuePairFloat' },
      ],
      __typename: 'BiteAi',
    },
    healthKit: { ignore: [], sourceIgnore: ['org.nutrisense'], __typename: 'HealthKit' },
    customIngredients: {
      macros: [
        { name: 'calories', indent: 0, __typename: 'Macro' },
        { name: 'totalFat', indent: 0, __typename: 'Macro' },
        { name: 'saturatedFat', indent: 1, __typename: 'Macro' },
        { name: 'transFat', indent: 1, __typename: 'Macro' },
        { name: 'polyunsaturatedFat', indent: 1, __typename: 'Macro' },
        { name: 'monounsaturatedFat', indent: 1, __typename: 'Macro' },
        { name: 'cholesterol', indent: 0, __typename: 'Macro' },
        { name: 'sodium', indent: 0, __typename: 'Macro' },
        { name: 'totalCarb', indent: 0, __typename: 'Macro' },
        { name: 'fiber', indent: 1, __typename: 'Macro' },
        { name: 'sugars', indent: 1, __typename: 'Macro' },
        { name: 'protein', indent: 0, __typename: 'Macro' },
      ],
      __typename: 'CustomIngredients',
    },
    settings: {
      cancellationPolicy:
        'https://support.nutrisense.io/en_us/how-to-cancel-your-program-ByDHk9CJgx',
      privacyPolicy: 'https://nutrisense.io/privacy-policy',
      termsOfUse: 'https://nutrisense.io/terms-of-use',
      telehealth: 'https://www.nutrisense.io/legal/telehealth',
      consumerHealthDataPrivacyPolicy:
        'https://www.nutrisense.io/legal/privacy-policy#consumer-health-data',
      supportForm: 'https://support.nutrisense.io/contact/submit-a-request-ryvilVKyge',
      medicalDisclaimer: 'https://www.nutrisense.io/legal/medical-disclaimer',
      courtesyReminder: 'https://www.nutrisense.io/legal/courtesy-reminder',
      hipaaAuthorization: 'https://www.nutrisense.io/legal/hipaa-authorization',
      __typename: 'Settings',
    },
    remindersSettings: {
      hoursInterval: {
        glucoseCheckOptions: [
          { text: '24 hours', value: 24.0, __typename: 'NumericalSelect' },
          { text: '23 hours', value: 23.0, __typename: 'NumericalSelect' },
          { text: '22 hours', value: 22.0, __typename: 'NumericalSelect' },
          { text: '21 hours', value: 21.0, __typename: 'NumericalSelect' },
          { text: '20 hours', value: 20.0, __typename: 'NumericalSelect' },
          { text: '19 hours', value: 19.0, __typename: 'NumericalSelect' },
          { text: '18 hours', value: 18.0, __typename: 'NumericalSelect' },
          { text: '17 hours', value: 17.0, __typename: 'NumericalSelect' },
          { text: '16 hours', value: 16.0, __typename: 'NumericalSelect' },
          { text: '15 hours', value: 15.0, __typename: 'NumericalSelect' },
          { text: '14 hours', value: 14.0, __typename: 'NumericalSelect' },
          { text: '13 hours', value: 13.0, __typename: 'NumericalSelect' },
          { text: '12 hours', value: 12.0, __typename: 'NumericalSelect' },
          { text: '11 hours', value: 11.0, __typename: 'NumericalSelect' },
          { text: '10 hours', value: 10.0, __typename: 'NumericalSelect' },
          { text: '9 hours', value: 9.0, __typename: 'NumericalSelect' },
          { text: '8 hours', value: 8.0, __typename: 'NumericalSelect' },
          { text: '7 hours', value: 7.0, __typename: 'NumericalSelect' },
          { text: '6 hours', value: 6.0, __typename: 'NumericalSelect' },
          { text: '5 hours', value: 5.0, __typename: 'NumericalSelect' },
          { text: '4 hours', value: 4.0, __typename: 'NumericalSelect' },
          { text: '3 hours', value: 3.0, __typename: 'NumericalSelect' },
          { text: '2 hours', value: 2.0, __typename: 'NumericalSelect' },
          { text: '1 hour', value: 1.0, __typename: 'NumericalSelect' },
        ],
        __typename: 'HoursInterval',
      },
      __typename: 'RemindersSettings',
    },
    healthSettings: {
      macroGoalSettings: {
        caloriesMax: 5000,
        proteinMax: 400,
        carbsMax: 750,
        fatMax: 750,
        __typename: 'MacroGoalSettings',
      },
      glucoseLowOptions: [
        { text: '40 mg/dL', value: 40.0, __typename: 'NumericalSelect' },
        { text: '50 mg/dL', value: 50.0, __typename: 'NumericalSelect' },
        { text: '60 mg/dL', value: 60.0, __typename: 'NumericalSelect' },
        { text: '70 mg/dL', value: 70.0, __typename: 'NumericalSelect' },
        { text: '80 mg/dL', value: 80.0, __typename: 'NumericalSelect' },
        { text: '90 mg/dL', value: 90.0, __typename: 'NumericalSelect' },
        { text: '100 mg/dL', value: 100.0, __typename: 'NumericalSelect' },
      ],
      glucoseHighOptions: [
        { text: '100 mg/dL', value: 100.0, __typename: 'NumericalSelect' },
        { text: '110 mg/dL', value: 110.0, __typename: 'NumericalSelect' },
        { text: '120 mg/dL', value: 120.0, __typename: 'NumericalSelect' },
        { text: '130 mg/dL', value: 130.0, __typename: 'NumericalSelect' },
        { text: '140 mg/dL', value: 140.0, __typename: 'NumericalSelect' },
        { text: '150 mg/dL', value: 150.0, __typename: 'NumericalSelect' },
        { text: '160 mg/dL', value: 160.0, __typename: 'NumericalSelect' },
        { text: '170 mg/dL', value: 170.0, __typename: 'NumericalSelect' },
        { text: '180 mg/dL', value: 180.0, __typename: 'NumericalSelect' },
        { text: '190 mg/dL', value: 190.0, __typename: 'NumericalSelect' },
        { text: '200 mg/dL', value: 200.0, __typename: 'NumericalSelect' },
      ],
      ketoneLowOptions: [
        { text: '0.0 mmol/L', value: 0.0, __typename: 'NumericalSelect' },
        { text: '0.1 mmol/L', value: 0.1, __typename: 'NumericalSelect' },
        { text: '0.2 mmol/L', value: 0.2, __typename: 'NumericalSelect' },
        { text: '0.3 mmol/L', value: 0.3, __typename: 'NumericalSelect' },
        { text: '0.4 mmol/L', value: 0.4, __typename: 'NumericalSelect' },
        { text: '0.5 mmol/L', value: 0.5, __typename: 'NumericalSelect' },
        { text: '0.6 mmol/L', value: 0.6, __typename: 'NumericalSelect' },
        { text: '0.7 mmol/L', value: 0.7, __typename: 'NumericalSelect' },
        { text: '0.8 mmol/L', value: 0.8, __typename: 'NumericalSelect' },
        { text: '0.9 mmol/L', value: 0.9, __typename: 'NumericalSelect' },
        { text: '1.0 mmol/L', value: 1.0, __typename: 'NumericalSelect' },
        { text: '1.1 mmol/L', value: 1.1, __typename: 'NumericalSelect' },
        { text: '1.2 mmol/L', value: 1.2, __typename: 'NumericalSelect' },
        { text: '1.3 mmol/L', value: 1.3, __typename: 'NumericalSelect' },
        { text: '1.4 mmol/L', value: 1.4, __typename: 'NumericalSelect' },
        { text: '1.5 mmol/L', value: 1.5, __typename: 'NumericalSelect' },
        { text: '1.6 mmol/L', value: 1.6, __typename: 'NumericalSelect' },
        { text: '1.7 mmol/L', value: 1.7, __typename: 'NumericalSelect' },
        { text: '1.8 mmol/L', value: 1.8, __typename: 'NumericalSelect' },
        { text: '1.9 mmol/L', value: 1.9, __typename: 'NumericalSelect' },
        { text: '2.0 mmol/L', value: 2.0, __typename: 'NumericalSelect' },
      ],
      ketoneHighOptions: [
        { text: '2.0 mmol/L', value: 2.0, __typename: 'NumericalSelect' },
        { text: '2.1 mmol/L', value: 2.1, __typename: 'NumericalSelect' },
        { text: '2.2 mmol/L', value: 2.2, __typename: 'NumericalSelect' },
        { text: '2.3 mmol/L', value: 2.3, __typename: 'NumericalSelect' },
        { text: '2.4 mmol/L', value: 2.4, __typename: 'NumericalSelect' },
        { text: '2.5 mmol/L', value: 2.5, __typename: 'NumericalSelect' },
        { text: '2.6 mmol/L', value: 2.6, __typename: 'NumericalSelect' },
        { text: '2.7 mmol/L', value: 2.7, __typename: 'NumericalSelect' },
        { text: '2.8 mmol/L', value: 2.8, __typename: 'NumericalSelect' },
        { text: '2.9 mmol/L', value: 2.9, __typename: 'NumericalSelect' },
        { text: '3.0 mmol/L', value: 3.0, __typename: 'NumericalSelect' },
        { text: '3.1 mmol/L', value: 3.1, __typename: 'NumericalSelect' },
        { text: '3.2 mmol/L', value: 3.2, __typename: 'NumericalSelect' },
        { text: '3.3 mmol/L', value: 3.3, __typename: 'NumericalSelect' },
        { text: '3.4 mmol/L', value: 3.4, __typename: 'NumericalSelect' },
        { text: '3.5 mmol/L', value: 3.5, __typename: 'NumericalSelect' },
        { text: '3.6 mmol/L', value: 3.6, __typename: 'NumericalSelect' },
        { text: '3.7 mmol/L', value: 3.7, __typename: 'NumericalSelect' },
        { text: '3.8 mmol/L', value: 3.8, __typename: 'NumericalSelect' },
        { text: '3.9 mmol/L', value: 3.9, __typename: 'NumericalSelect' },
        { text: '4.0 mmol/L', value: 4.0, __typename: 'NumericalSelect' },
        { text: '4.1 mmol/L', value: 4.1, __typename: 'NumericalSelect' },
        { text: '4.2 mmol/L', value: 4.2, __typename: 'NumericalSelect' },
        { text: '4.3 mmol/L', value: 4.3, __typename: 'NumericalSelect' },
        { text: '4.4 mmol/L', value: 4.4, __typename: 'NumericalSelect' },
        { text: '4.5 mmol/L', value: 4.5, __typename: 'NumericalSelect' },
        { text: '4.6 mmol/L', value: 4.6, __typename: 'NumericalSelect' },
        { text: '4.7 mmol/L', value: 4.7, __typename: 'NumericalSelect' },
        { text: '4.8 mmol/L', value: 4.8, __typename: 'NumericalSelect' },
        { text: '4.9 mmol/L', value: 4.9, __typename: 'NumericalSelect' },
        { text: '5.0 mmol/L', value: 5.0, __typename: 'NumericalSelect' },
        { text: '5.1 mmol/L', value: 5.1, __typename: 'NumericalSelect' },
        { text: '5.2 mmol/L', value: 5.2, __typename: 'NumericalSelect' },
        { text: '5.3 mmol/L', value: 5.3, __typename: 'NumericalSelect' },
        { text: '5.4 mmol/L', value: 5.4, __typename: 'NumericalSelect' },
        { text: '5.5 mmol/L', value: 5.5, __typename: 'NumericalSelect' },
        { text: '5.6 mmol/L', value: 5.6, __typename: 'NumericalSelect' },
        { text: '5.7 mmol/L', value: 5.7, __typename: 'NumericalSelect' },
        { text: '5.8 mmol/L', value: 5.8, __typename: 'NumericalSelect' },
        { text: '5.9 mmol/L', value: 5.9, __typename: 'NumericalSelect' },
        { text: '6.0 mmol/L', value: 6.0, __typename: 'NumericalSelect' },
        { text: '6.1 mmol/L', value: 6.1, __typename: 'NumericalSelect' },
        { text: '6.2 mmol/L', value: 6.2, __typename: 'NumericalSelect' },
        { text: '6.3 mmol/L', value: 6.3, __typename: 'NumericalSelect' },
        { text: '6.4 mmol/L', value: 6.4, __typename: 'NumericalSelect' },
        { text: '6.5 mmol/L', value: 6.5, __typename: 'NumericalSelect' },
        { text: '6.6 mmol/L', value: 6.6, __typename: 'NumericalSelect' },
        { text: '6.7 mmol/L', value: 6.7, __typename: 'NumericalSelect' },
        { text: '6.8 mmol/L', value: 6.8, __typename: 'NumericalSelect' },
        { text: '6.9 mmol/L', value: 6.9, __typename: 'NumericalSelect' },
        { text: '7.0 mmol/L', value: 7.0, __typename: 'NumericalSelect' },
        { text: '7.1 mmol/L', value: 7.1, __typename: 'NumericalSelect' },
        { text: '7.2 mmol/L', value: 7.2, __typename: 'NumericalSelect' },
        { text: '7.3 mmol/L', value: 7.3, __typename: 'NumericalSelect' },
        { text: '7.4 mmol/L', value: 7.4, __typename: 'NumericalSelect' },
        { text: '7.5 mmol/L', value: 7.5, __typename: 'NumericalSelect' },
        { text: '7.6 mmol/L', value: 7.6, __typename: 'NumericalSelect' },
        { text: '7.7 mmol/L', value: 7.7, __typename: 'NumericalSelect' },
        { text: '7.8 mmol/L', value: 7.8, __typename: 'NumericalSelect' },
        { text: '7.9 mmol/L', value: 7.9, __typename: 'NumericalSelect' },
        { text: '8.0 mmol/L', value: 8.0, __typename: 'NumericalSelect' },
      ],
      dashboardGraphOptions: [
        { text: 'Glucose', value: 'glucose', __typename: 'StringSelect' },
        { text: 'Glucose + Ketones', value: 'combined', __typename: 'StringSelect' },
      ],
      unitSystemOptions: [
        { text: 'Imperial', value: 'imperial', __typename: 'StringSelect' },
        { text: 'Metric', value: 'metric', __typename: 'StringSelect' },
      ],
      glucoseThresholdPresets: [
        {
          name: 'Restricted',
          description:
            'For those following a very low-carbohydrate/no-carbohydrate dietary approach.',
          low: 70,
          high: 120,
          __typename: 'GlucoseThresholdPreset',
        },
        {
          name: 'Balanced',
          description: 'Best for most individuals.',
          low: 70,
          high: 140,
          __typename: 'GlucoseThresholdPreset',
        },
        {
          name: 'Expanded',
          description: 'For those that are working on improving their glucose control.',
          low: 70,
          high: 180,
          __typename: 'GlucoseThresholdPreset',
        },
      ],
      __typename: 'HealthSettings',
    },
    sensorSettings: {
      baselineAdjustmentOptions: [
        { text: '-70 mg/dL', value: -70.0, __typename: 'NumericalSelect' },
        { text: '-65 mg/dL', value: -65.0, __typename: 'NumericalSelect' },
        { text: '-60 mg/dL', value: -60.0, __typename: 'NumericalSelect' },
        { text: '-55 mg/dL', value: -55.0, __typename: 'NumericalSelect' },
        { text: '-50 mg/dL', value: -50.0, __typename: 'NumericalSelect' },
        { text: '-45 mg/dL', value: -45.0, __typename: 'NumericalSelect' },
        { text: '-40 mg/dL', value: -40.0, __typename: 'NumericalSelect' },
        { text: '-35 mg/dL', value: -35.0, __typename: 'NumericalSelect' },
        { text: '-30 mg/dL', value: -30.0, __typename: 'NumericalSelect' },
        { text: '-25 mg/dL', value: -25.0, __typename: 'NumericalSelect' },
        { text: '-20 mg/dL', value: -20.0, __typename: 'NumericalSelect' },
        { text: '-15 mg/dL', value: -15.0, __typename: 'NumericalSelect' },
        { text: '-10 mg/dL', value: -10.0, __typename: 'NumericalSelect' },
        { text: '-5 mg/dL', value: -5.0, __typename: 'NumericalSelect' },
        { text: '0 mg/dL', value: 0.0, __typename: 'NumericalSelect' },
        { text: '+5 mg/dL', value: 5.0, __typename: 'NumericalSelect' },
        { text: '+10 mg/dL', value: 10.0, __typename: 'NumericalSelect' },
        { text: '+15 mg/dL', value: 15.0, __typename: 'NumericalSelect' },
        { text: '+20 mg/dL', value: 20.0, __typename: 'NumericalSelect' },
        { text: '+25 mg/dL', value: 25.0, __typename: 'NumericalSelect' },
        { text: '+30 mg/dL', value: 30.0, __typename: 'NumericalSelect' },
        { text: '+35 mg/dL', value: 35.0, __typename: 'NumericalSelect' },
        { text: '+40 mg/dL', value: 40.0, __typename: 'NumericalSelect' },
        { text: '+45 mg/dL', value: 45.0, __typename: 'NumericalSelect' },
        { text: '+50 mg/dL', value: 50.0, __typename: 'NumericalSelect' },
        { text: '+55 mg/dL', value: 55.0, __typename: 'NumericalSelect' },
        { text: '+60 mg/dL', value: 60.0, __typename: 'NumericalSelect' },
        { text: '+65 mg/dL', value: 65.0, __typename: 'NumericalSelect' },
        { text: '+70 mg/dL', value: 70.0, __typename: 'NumericalSelect' },
      ],
      __typename: 'SensorSettings',
    },
    referral: {
      title: 'Get $25 Off, Gift $25 Off',
      discount: 25,
      discountPercentage: null,
      credits: 25,
      description:
        'Invite a friend to Nutrisense and you will both receive discount for your next full month of service.',
      message:
        'Sign up for Nutrisense with my discount code to get $25 off your next month of service.',
      kind: 'credits',
      __typename: 'Referral',
    },
    onboarding: {
      tutorials: [
        {
          key: 'mealDetails',
          value: [
            {
              title: 'Meal Score',
              description:
                'Peak is how high your glucose spiked after the meal. \\pExposure is the area under the glucose curve for 2 hours following the meal. \\pStability measures how much of a glucose jump you had. \\pRecovery is how close your 2 hour glucose value is to your pre-meal glucose value.',
              photoUrlLight:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/light/meal_details_score.png',
              photoUrlDark:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/dark/meal_details_score.png',
              videoUrl: null,
              __typename: 'TutorialStep',
            },
            {
              title: 'Meal Chart',
              description:
                'The meal chart shows you the raw data we use to calculate your meal score. \\pMax is how high your glucose spiked after a meal. \\pArea is the area under the curve.  \\pDelta measures how much of a glucose jump you had. \\p2 hour delta is how close your 2 hour glucose value is to your pre-meal glucose value.',
              photoUrlLight:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/light/meal_details_chart.png',
              photoUrlDark:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/dark/meal_details_chart.png',
              videoUrl: null,
              __typename: 'TutorialStep',
            },
            {
              title: 'Meal Macro Summary',
              description:
                'The meal macro summary shows you the macronutrient composition of each meal. \\pYou can set your macro goals in the Member Settings.',
              photoUrlLight:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/light/summary_macros.png',
              photoUrlDark:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/dark/summary_macros.png',
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'calendar',
          value: [
            {
              title: 'Calendar',
              description:
                'The calendar allows you to quickly jump to a different day or to select up to a 120-day date range. \\pTo select a multi-day range, simply tap and hold on any calendar day, then tap the end of the range to finish the selection.',
              photoUrlLight:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/light/calendar.png',
              photoUrlDark:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/dark/calendar.png',
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'calibration',
          value: [
            {
              title: 'Calibration',
              description:
                'The CGM accurately captures changes in glucose levels; however, all CGM devices can sometimes be calibrated slightly higher or lower from the factory. \\pThe manual calibration feature allows you to adjust the CGM data by using a recent fasting glucose value from a lab or from a blood glucose meter at home. Making a baseline adjustment of "-20" will shift the CGM data and all statistics 20 points lower. \\pWe recommend only using fasting glucose values to calibrate the CGM. This will guarantee that your glucose is stable at the time of calibration. We also recommend avoiding manual calibration until you have worn the device for at least 24 hours.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'timelineGlucoseChart',
          value: [
            {
              title: 'How To Read The Glucose Chart?',
              description:
                'The line on the chart represents the glucose data from your CGM. A green line indicates your values are within target range. An orange or red line indicates your values are outside of the target range.',
              photoUrlLight:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/light/glucose_line_chart.png',
              photoUrlDark:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/dark/glucose_line_chart.png',
              videoUrl: null,
              __typename: 'TutorialStep',
            },
            {
              title: 'Adding events',
              description:
                'To connect specific events to your glucose values, use the green plus button on the Home screen to log events such as meals, activities, and measurements. The dots on the graph will represent these logged events.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'timelineGlucoseRanges',
          value: [
            {
              title: 'Target Ranges',
              description:
                'The default target range is 70-140 mg/dl. We want to keep glucose spikes within this range as much as possible, but we also want to avoid major shifts in glucose even if it is staying in the green the whole time.\\pPlease note that target ranges may vary depending on your health status and can be adjusted in Chart Settings.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'timelineKetoneChart',
          value: [
            {
              title: 'How To Read The Ketone Chart?',
              description:
                'The line on the chart represents your blood ketone measurements.\\pSync KetoMojo with your Nutrisense app to track your blood ketones or log manually using the green plus button on the Home screen (add as a measurement).',
              photoUrlLight:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/light/ketone_line_chart.png',
              photoUrlDark:
                'https://global-assets.nutrisense.io/tutorials-v2.7.0/dark/ketone_line_chart.png',
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'timelineKetoneRanges',
          value: [
            {
              title: 'Ketone Ranges',
              description:
                'The default target range is 0.5-3 mmol/L, which is the range for optimal ketosis. Note there is no health benefit for achieving ketone values \u003e3 mmol.\\pIf your ketones are \u003e8 mmol/L, check your glucose values. If glucose values are \u003e240 mg/dL, please refer to your healthcare provider.\\pTarget range can be adjusted in Chart Settings.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'dailyGlucoseScore',
          value: [
            {
              title: 'Daily Glucose Score',
              description:
                'This score is composed of 4 glucose metrics for the selected time period: peak, average, adaptability, and variability. A higher score indicates better glycemic control.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'scorePeak',
          value: [
            {
              title: 'Peak',
              description: 'Your highest glucose value.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'scoreMean',
          value: [
            {
              title: 'Average',
              description: 'Your average glucose value.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'scoreTimeOutsideRange',
          value: [
            {
              title: 'Adaptability',
              description: 'The amount of time spent above your glucose threshold.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
        {
          key: 'scoreStdDev',
          value: [
            {
              title: 'Variability',
              description: 'Your standard deviation or the “swings” in your glucose data.',
              photoUrlLight: null,
              photoUrlDark: null,
              videoUrl: null,
              __typename: 'TutorialStep',
            },
          ],
          __typename: 'Tutorials',
        },
      ],
      __typename: 'Onboarding',
    },
    score: { warning: 79, danger: 49, max: 100, __typename: 'Score' },
    questionnaireUrl: 'https://nutrisense.typeform.com/to/mALF9G91#email=${EMAIL}',
    privacyCenterUrl: 'https://nutrisense.privacy.saymine.io/Nutrisense',
    usStates: [
      { name: 'Alaska', abbreviation: 'AK', __typename: 'State' },
      { name: 'Alabama', abbreviation: 'AL', __typename: 'State' },
      { name: 'Arizona', abbreviation: 'AZ', __typename: 'State' },
      { name: 'Arkansas', abbreviation: 'AR', __typename: 'State' },
      { name: 'California', abbreviation: 'CA', __typename: 'State' },
      { name: 'Colorado', abbreviation: 'CO', __typename: 'State' },
      { name: 'Connecticut', abbreviation: 'CT', __typename: 'State' },
      { name: 'Delaware', abbreviation: 'DE', __typename: 'State' },
      { name: 'District of Columbia', abbreviation: 'DC', __typename: 'State' },
      { name: 'Florida', abbreviation: 'FL', __typename: 'State' },
      { name: 'Georgia', abbreviation: 'GA', __typename: 'State' },
      { name: 'Guam', abbreviation: 'GU', __typename: 'State' },
      { name: 'Hawaii', abbreviation: 'HI', __typename: 'State' },
      { name: 'Idaho', abbreviation: 'ID', __typename: 'State' },
      { name: 'Illinois', abbreviation: 'IL', __typename: 'State' },
      { name: 'Indiana', abbreviation: 'IN', __typename: 'State' },
      { name: 'Iowa', abbreviation: 'IA', __typename: 'State' },
      { name: 'Kansas', abbreviation: 'KS', __typename: 'State' },
      { name: 'Kentucky', abbreviation: 'KY', __typename: 'State' },
      { name: 'Louisiana', abbreviation: 'LA', __typename: 'State' },
      { name: 'Maine', abbreviation: 'ME', __typename: 'State' },
      { name: 'Maryland', abbreviation: 'MD', __typename: 'State' },
      { name: 'Massachusetts', abbreviation: 'MA', __typename: 'State' },
      { name: 'Michigan', abbreviation: 'MI', __typename: 'State' },
      { name: 'Minnesota', abbreviation: 'MN', __typename: 'State' },
      { name: 'Mississippi', abbreviation: 'MS', __typename: 'State' },
      { name: 'Missouri', abbreviation: 'MO', __typename: 'State' },
      { name: 'Montana', abbreviation: 'MT', __typename: 'State' },
      { name: 'Nebraska', abbreviation: 'NE', __typename: 'State' },
      { name: 'Nevada', abbreviation: 'NV', __typename: 'State' },
      { name: 'New Hampshire', abbreviation: 'NH', __typename: 'State' },
      { name: 'New Jersey', abbreviation: 'NJ', __typename: 'State' },
      { name: 'New Mexico', abbreviation: 'NM', __typename: 'State' },
      { name: 'New York', abbreviation: 'NY', __typename: 'State' },
      { name: 'North Carolina', abbreviation: 'NC', __typename: 'State' },
      { name: 'North Dakota', abbreviation: 'ND', __typename: 'State' },
      { name: 'Ohio', abbreviation: 'OH', __typename: 'State' },
      { name: 'Oklahoma', abbreviation: 'OK', __typename: 'State' },
      { name: 'Oregon', abbreviation: 'OR', __typename: 'State' },
      { name: 'Pennsylvania', abbreviation: 'PA', __typename: 'State' },
      { name: 'Puerto Rico', abbreviation: 'PR', __typename: 'State' },
      { name: 'Rhode Island', abbreviation: 'RI', __typename: 'State' },
      { name: 'South Carolina', abbreviation: 'SC', __typename: 'State' },
      { name: 'South Dakota', abbreviation: 'SD', __typename: 'State' },
      { name: 'Tennessee', abbreviation: 'TN', __typename: 'State' },
      { name: 'Texas', abbreviation: 'TX', __typename: 'State' },
      { name: 'Utah', abbreviation: 'UT', __typename: 'State' },
      { name: 'Vermont', abbreviation: 'VT', __typename: 'State' },
      { name: 'Virginia', abbreviation: 'VA', __typename: 'State' },
      { name: 'Washington', abbreviation: 'WA', __typename: 'State' },
      { name: 'West Virginia', abbreviation: 'WV', __typename: 'State' },
      { name: 'Wisconsin', abbreviation: 'WI', __typename: 'State' },
      { name: 'Wyoming', abbreviation: 'WY', __typename: 'State' },
    ],
    caProvinces: [
      { name: 'Alaska', abbreviation: 'AB', __typename: 'State' },
      { name: 'British Columbia', abbreviation: 'BC', __typename: 'State' },
      { name: 'Manitoba', abbreviation: 'MB', __typename: 'State' },
      { name: 'New Brunswick', abbreviation: 'NB', __typename: 'State' },
      { name: 'Newfoundland and Labrador', abbreviation: 'NL', __typename: 'State' },
      { name: 'Northwest Territories', abbreviation: 'NT', __typename: 'State' },
      { name: 'Nova Scotia', abbreviation: 'NS', __typename: 'State' },
      { name: 'Nunavut', abbreviation: 'NU', __typename: 'State' },
      { name: 'Prince Edward Island', abbreviation: 'PE', __typename: 'State' },
      { name: 'Ontario', abbreviation: 'ON', __typename: 'State' },
      { name: 'Quebec', abbreviation: 'QC', __typename: 'State' },
      { name: 'Saskatchewan', abbreviation: 'SK', __typename: 'State' },
      { name: 'Yukon', abbreviation: 'YT', __typename: 'State' },
    ],
    goalOptions: [
      {
        text: 'Experiment with food & glucose',
        value: 'learn_about_glucose_levels',
        __typename: 'GoalOption',
      },
      { text: 'Lose weight or control cravings', value: 'lose_weight', __typename: 'GoalOption' },
      {
        text: 'Lower or improve glucose values',
        value: 'improve_glucose_values',
        __typename: 'GoalOption',
      },
      {
        text: 'Optimize fitness performance',
        value: 'optimize_fitness_performance',
        __typename: 'GoalOption',
      },
      { text: 'Improve long-term health', value: 'prevent_disease', __typename: 'GoalOption' },
      { text: 'Promote longevity', value: 'promote_longevity', __typename: 'GoalOption' },
      {
        text: 'Improve daily wellness',
        value: 'manage_chronic_condition',
        __typename: 'GoalOption',
      },
      { text: 'Other', value: 'other', __typename: 'GoalOption' },
    ],
    goalMetricOptions: [
      { text: 'Time in Range', value: 'glucose_time_within_range', __typename: 'GoalMetricOption' },
      { text: 'Variability', value: 'glucose_standard_deviation', __typename: 'GoalMetricOption' },
      { text: 'Average', value: 'glucose_mean', __typename: 'GoalMetricOption' },
      { text: 'Min', value: 'glucose_min', __typename: 'GoalMetricOption' },
      { text: 'Max', value: 'glucose_max', __typename: 'GoalMetricOption' },
      { text: 'Sleep Average', value: 'glucose_sleep_average', __typename: 'GoalMetricOption' },
      { text: 'Morning Average', value: 'glucose_morning_average', __typename: 'GoalMetricOption' },
      { text: 'Weight', value: 'measurements_weight', __typename: 'GoalMetricOption' },
      { text: 'Mood', value: 'journal_mood', __typename: 'GoalMetricOption' },
      { text: 'Energy', value: 'journal_energy', __typename: 'GoalMetricOption' },
      { text: 'Focus', value: 'journal_focus', __typename: 'GoalMetricOption' },
      { text: 'Stress', value: 'journal_stress', __typename: 'GoalMetricOption' },
      { text: 'Appetite', value: 'journal_appetite', __typename: 'GoalMetricOption' },
    ],
    healthData: {
      measurementTypeDefs: [
        {
          key: 'glucose',
          label: 'Glucose',
          isDailyMeasurement: false,
          isJournalMeasurement: false,
          icon: null,
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'blood_glucose',
          label: 'Blood Glucose',
          isDailyMeasurement: false,
          isJournalMeasurement: false,
          icon: 'drop',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'blood_ketones',
          label: 'Blood Ketones',
          isDailyMeasurement: false,
          isJournalMeasurement: false,
          icon: 'drop',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'breath_ketones',
          label: 'Breath Ketones',
          isDailyMeasurement: false,
          isJournalMeasurement: false,
          icon: 'chart_line',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'body_fat_percentage',
          label: 'Body Fat Percentage',
          isDailyMeasurement: false,
          isJournalMeasurement: false,
          icon: 'percent',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'body_temperature',
          label: 'Body Temperature',
          isDailyMeasurement: false,
          isJournalMeasurement: false,
          icon: 'thermometer',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'weight',
          label: 'Weight',
          isDailyMeasurement: false,
          isJournalMeasurement: false,
          icon: 'scales',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'blood_pressure',
          label: 'Blood Pressure',
          isDailyMeasurement: false,
          isJournalMeasurement: false,
          icon: 'drop',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'step_count',
          label: 'Step Count',
          isDailyMeasurement: true,
          isJournalMeasurement: false,
          icon: 'footprints',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'exercise_time',
          label: 'Exercise Time',
          isDailyMeasurement: true,
          isJournalMeasurement: false,
          icon: 'timer',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'flights_climbed',
          label: 'Flights Climbed',
          isDailyMeasurement: true,
          isJournalMeasurement: false,
          icon: 'steps',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'running_distance',
          label: 'Running Distance',
          isDailyMeasurement: true,
          isJournalMeasurement: false,
          icon: 'person_simple_run',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'cycling_distance',
          label: 'Cycling Distance',
          isDailyMeasurement: true,
          isJournalMeasurement: false,
          icon: 'person_simple_bike',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'swimming_distance',
          label: 'Swimming Distance',
          isDailyMeasurement: true,
          isJournalMeasurement: false,
          icon: 'person_simple_swim',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'stress',
          label: 'Stress',
          isDailyMeasurement: false,
          isJournalMeasurement: true,
          icon: 'hand_heart',
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'mood',
          label: 'Mood',
          isDailyMeasurement: false,
          isJournalMeasurement: true,
          icon: null,
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'energy',
          label: 'Energy',
          isDailyMeasurement: false,
          isJournalMeasurement: true,
          icon: null,
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'focus',
          label: 'Focus',
          isDailyMeasurement: false,
          isJournalMeasurement: true,
          icon: null,
          __typename: 'HealthDataMeasurementTypeDef',
        },
        {
          key: 'appetite',
          label: 'Appetite',
          isDailyMeasurement: false,
          isJournalMeasurement: true,
          icon: null,
          __typename: 'HealthDataMeasurementTypeDef',
        },
      ],
      measurementSourceDefs: [
        {
          key: 'nutrisense',
          label: 'Nutrisense',
          providesDailyMeasurements: true,
          sourceTags: ['nutrisense'],
          iconDef: { pack: 'customImage', name: 'nutrisense', __typename: 'IconDef' },
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'healthkit',
          label: 'Apple Health',
          providesDailyMeasurements: true,
          sourceTags: ['healthkit', 'apple'],
          iconDef: { pack: 'customImage', name: 'appleHealth', __typename: 'IconDef' },
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'googlefit',
          label: 'Google Fit',
          providesDailyMeasurements: true,
          sourceTags: ['googlefit', 'google'],
          iconDef: { pack: 'customImage', name: 'googleFitIcon', __typename: 'IconDef' },
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'dexcom',
          label: 'Dexcom',
          providesDailyMeasurements: false,
          sourceTags: ['dexcom'],
          iconDef: null,
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'fitbit',
          label: 'Fitbit',
          providesDailyMeasurements: true,
          sourceTags: ['fitbit'],
          iconDef: { pack: 'customImage', name: 'fitbitIcon', __typename: 'IconDef' },
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'freestylelibre',
          label: 'FreeStyle Libre',
          providesDailyMeasurements: false,
          sourceTags: ['freestylelibre'],
          iconDef: { pack: 'customImage', name: 'freeStyleLibreIcon', __typename: 'IconDef' },
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'garmin',
          label: 'Garmin',
          providesDailyMeasurements: true,
          sourceTags: ['garmin'],
          iconDef: { pack: 'customImage', name: 'garminIcon', __typename: 'IconDef' },
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'ketomojo',
          label: 'KetoMojo',
          providesDailyMeasurements: false,
          sourceTags: ['ketomojo'],
          iconDef: null,
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'libre_linkup',
          label: 'Libre Linkup',
          providesDailyMeasurements: false,
          sourceTags: ['libre_linkup'],
          iconDef: null,
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'oura',
          label: 'Oura',
          providesDailyMeasurements: true,
          sourceTags: ['oura'],
          iconDef: { pack: 'customImage', name: 'ouraIcon', __typename: 'IconDef' },
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'whoop',
          label: 'Whoop',
          providesDailyMeasurements: true,
          sourceTags: ['whoop'],
          iconDef: null,
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'health_connect',
          label: 'Health Connect',
          providesDailyMeasurements: true,
          sourceTags: ['health_connect'],
          iconDef: { pack: 'customImage', name: 'healthConnect', __typename: 'IconDef' },
          __typename: 'HealthDataMeasurementSourceDef',
        },
        {
          key: 'lingo',
          label: 'Lingo',
          providesDailyMeasurements: false,
          sourceTags: ['lingo'],
          iconDef: null,
          __typename: 'HealthDataMeasurementSourceDef',
        },
      ],
      __typename: 'HealthDataConfig',
    },
    journal: {
      range: { min: 1, max: 5, __typename: 'JournalRange' },
      measurementTypes: [
        { type: 'Mood', reverse: null, __typename: 'MeasurementType' },
        { type: 'Energy', reverse: null, __typename: 'MeasurementType' },
        { type: 'Focus', reverse: null, __typename: 'MeasurementType' },
        { type: 'Stress', reverse: true, __typename: 'MeasurementType' },
        { type: 'Appetite', reverse: null, __typename: 'MeasurementType' },
      ],
      __typename: 'JournalConfig',
    },
    chatbot: {
      lastShownCutoffAt: '2023-08-23T00:00:00-07:00',
      responseTimeoutInSeconds: 120,
      disclosure: 'This is not medical advice. Nora may be wrong.\nAlways consult your doctor.',
      __typename: 'Chatbot',
    },
    reminders: [
      {
        allowedFrequencies: [{ key: 'daily', __typename: 'ReminderFrequency' }],
        icon: 'fork-knife',
        key: 'breakfast',
        title: 'Log Breakfast',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [{ key: 'daily', __typename: 'ReminderFrequency' }],
        icon: 'fork-knife',
        key: 'lunch',
        title: 'Log Lunch',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [{ key: 'daily', __typename: 'ReminderFrequency' }],
        icon: 'fork-knife',
        key: 'dinner',
        title: 'Log Dinner',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [{ key: 'daily', __typename: 'ReminderFrequency' }],
        icon: 'fork-knife',
        key: 'other_meal',
        title: 'Log Meal',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [
          { key: 'daily', __typename: 'ReminderFrequency' },
          { key: 'weekly', __typename: 'ReminderFrequency' },
        ],
        icon: 'person-simple-run',
        key: 'exercise',
        title: 'Log Exercise',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [
          { key: 'daily', __typename: 'ReminderFrequency' },
          { key: 'weekly', __typename: 'ReminderFrequency' },
        ],
        icon: 'prohibit',
        key: 'fasting',
        title: 'Log Fasting',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [
          { key: 'daily', __typename: 'ReminderFrequency' },
          { key: 'weekly', __typename: 'ReminderFrequency' },
        ],
        icon: 'flower-lotus',
        key: 'meditation',
        title: 'Log Meditation',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [{ key: 'daily', __typename: 'ReminderFrequency' }],
        icon: 'moon',
        key: 'sleep',
        title: 'Log Sleep',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [
          { key: 'daily', __typename: 'ReminderFrequency' },
          { key: 'weekly', __typename: 'ReminderFrequency' },
        ],
        icon: 'pencil-simple-line',
        key: 'journal',
        title: 'Log Journal',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [{ key: 'hours_interval', __typename: 'ReminderFrequency' }],
        icon: 'bell-ringing',
        key: 'glucose_check',
        title: 'Check Glucose',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [
          { key: 'daily', __typename: 'ReminderFrequency' },
          { key: 'weekly', __typename: 'ReminderFrequency' },
        ],
        icon: 'ruler',
        key: 'weight',
        title: 'Log Weight',
        __typename: 'ReminderKind',
      },
      {
        allowedFrequencies: [
          { key: 'monthly', __typename: 'ReminderFrequency' },
          { key: 'bimonthly', __typename: 'ReminderFrequency' },
          { key: 'quarterly', __typename: 'ReminderFrequency' },
        ],
        icon: 'calendar-plus',
        key: 'submit_lab_results',
        title: 'Submit Lab Results',
        __typename: 'ReminderKind',
      },
    ],
    appointmentKinds: [
      {
        key: 'initial',
        duration: '90',
        title: '90 Minute Nutrition Call',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'initial_60',
        duration: '60',
        title: '60 Minute Nutrition Call',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'followup',
        duration: '60',
        title: '60 Minute Nutrition Call',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'none_covered',
        duration: '30',
        title: '30 Minute Nutrition Call',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'followup_90',
        duration: '90',
        title: '90 Minute Nutrition Call',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'followup_30',
        duration: '30',
        title: '30 Minute Nutrition Call',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'followup_45',
        duration: '45',
        title: '45 Minute Nutrition Call',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'dpp_session',
        duration: '60',
        title: 'Diabetes Prevention Program Session',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'glp_session',
        duration: '5',
        title: 'GLP Session',
        coachingKind: {
          key: 'medical',
          coachTitle: 'Doctor',
          shortCoachTitle: 'Doctor',
          hubTitle: 'Care Hub',
          shortHubTitle: 'Care',
          serviceTitle: 'Care',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'glp_session_10',
        duration: '10',
        title: 'GLP Session',
        coachingKind: {
          key: 'medical',
          coachTitle: 'Doctor',
          shortCoachTitle: 'Doctor',
          hubTitle: 'Care Hub',
          shortHubTitle: 'Care',
          serviceTitle: 'Care',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'dp_webinar_session',
        duration: '60',
        title: 'Prevent Type 2 Session',
        coachingKind: {
          key: 'mnt',
          coachTitle: 'Nutritionist',
          shortCoachTitle: 'Nutritionist',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Nutrition',
          clinical: true,
          insuranceReimbursable: true,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'uhc_health_coaching',
        duration: '30',
        title: '30 Minute Video Call',
        coachingKind: {
          key: 'health_coaching',
          coachTitle: 'Health Coach',
          shortCoachTitle: 'Coach',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Health Coaching',
          clinical: false,
          insuranceReimbursable: false,
          primary: true,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'stress_management',
        duration: '60',
        title: '60 Minute Stress Management Call',
        coachingKind: {
          key: 'stress_management',
          coachTitle: 'Stress Management Coach',
          shortCoachTitle: 'Coach',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Stress Management',
          clinical: true,
          insuranceReimbursable: true,
          primary: false,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
      {
        key: 'stress_management_mnt',
        duration: '60',
        title: '60 Minute Stress Management Call',
        coachingKind: {
          key: 'stress_management',
          coachTitle: 'Stress Management Coach',
          shortCoachTitle: 'Coach',
          hubTitle: 'Coach Hub',
          shortHubTitle: 'Coach',
          serviceTitle: 'Stress Management',
          clinical: true,
          insuranceReimbursable: true,
          primary: false,
          __typename: 'CoachesCoachingKindDef',
        },
        __typename: 'ClientConfigEhrAppointmentKind',
      },
    ],
    healthMetrics: [
      {
        key: 'weight',
        label: 'Weight',
        unit: null,
        kind: 'measurement',
        __typename: 'HealthMetricType',
      },
      {
        key: 'height',
        label: 'Height',
        unit: 'in',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      { key: 'bmi', label: 'BMI', unit: null, kind: 'biomarker', __typename: 'HealthMetricType' },
      {
        key: 'blood_pressure',
        label: 'Blood Pressure',
        unit: null,
        kind: 'measurement',
        __typename: 'HealthMetricType',
      },
      {
        key: 'fasted_glucose',
        label: 'Glucose (fasted)',
        unit: 'mg/dL',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'fasted_insulin',
        label: 'Insulin (fasted)',
        unit: 'mIU/L',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'hb_a1c',
        label: 'HbA1c',
        unit: '%',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'ldl_cholesterol',
        label: 'LDL Cholesterol',
        unit: 'mg/dL',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'hdl_cholesterol',
        label: 'HDL Cholesterol',
        unit: 'mg/dL',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'total_cholesterol',
        label: 'Total Cholesterol',
        unit: 'mg/dL',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'triglycerides',
        label: 'Triglycerides',
        unit: 'mg/dL',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'vitamin_d',
        label: 'Vitamin D',
        unit: 'ng/mL',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'tsh',
        label: 'TSH',
        unit: 'mIU/mL',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
      {
        key: 'hs_crp',
        label: 'hsCRP',
        unit: 'mg/L',
        kind: 'biomarker',
        __typename: 'HealthMetricType',
      },
    ],
    biomarkers: [
      {
        label: 'Glucose (fasted)',
        unit: 'mg/dL',
        kind: 'fasted_glucose',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Insulin (fasted)',
        unit: 'mIU/L',
        kind: 'fasted_insulin',
        __typename: 'BiomarkerConfig',
      },
      { label: 'HbA1c', unit: '%', kind: 'hb_a1c', __typename: 'BiomarkerConfig' },
      { label: 'hsCRP', unit: 'mg/L', kind: 'hs_crp', __typename: 'BiomarkerConfig' },
      {
        label: 'LDL Cholesterol',
        unit: 'mg/dL',
        kind: 'ldl_cholesterol',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'HDL Cholesterol',
        unit: 'mg/dL',
        kind: 'hdl_cholesterol',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Total Cholesterol',
        unit: 'mg/dL',
        kind: 'total_cholesterol',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Triglycerides',
        unit: 'mg/dL',
        kind: 'triglycerides',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Vitamin D', unit: 'ng/mL', kind: 'vitamin_d', __typename: 'BiomarkerConfig' },
      { label: 'TSH', unit: 'mIU/mL', kind: 'tsh', __typename: 'BiomarkerConfig' },
      { label: 'Height', unit: 'in', kind: 'height', __typename: 'BiomarkerConfig' },
      { label: 'BMI', unit: null, kind: 'bmi', __typename: 'BiomarkerConfig' },
      { label: 'Weight', unit: 'lb', kind: 'weight', __typename: 'BiomarkerConfig' },
      {
        label: 'Systolic Blood Pressure',
        unit: 'mmHg',
        kind: 'systolic_blood_pressure',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Diastolic Blood Pressure',
        unit: 'mmHg',
        kind: 'diastolic_blood_pressure',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Apolipoprotein B',
        unit: 'mg/dL',
        kind: 'apolipoprotein_b',
        __typename: 'BiomarkerConfig',
      },
      { label: 'C Peptide', unit: 'ng/mL', kind: 'c_peptide', __typename: 'BiomarkerConfig' },
      {
        label: 'Vitamin D, 25-OH',
        unit: 'ng/mL',
        kind: 'vitamin_d_25_oh',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Uric Acid', unit: 'mg/dL', kind: 'uric_acid', __typename: 'BiomarkerConfig' },
      {
        label: 'Homocysteine',
        unit: 'µmol/L',
        kind: 'homocysteine',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Linoleic Acid',
        unit: '% of RBC fatty acids',
        kind: 'linoleic_acid',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Arachidonic Acid',
        unit: 'Ratio',
        kind: 'arachidonic_acid',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Eicosapentaenoic Acid (EPA)',
        unit: '%',
        kind: 'epa',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Docosahexaenoic Acid (DHA)',
        unit: '%',
        kind: 'dha',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Docosapentaenoic Acid (DPA)',
        unit: '%',
        kind: 'dpa',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Omega 6, Total', unit: '%', kind: 'omega_6_total', __typename: 'BiomarkerConfig' },
      { label: 'Omega 3 Total', unit: '%', kind: 'omega_3_total', __typename: 'BiomarkerConfig' },
      { label: 'EPA+DPA+DHA', unit: '%', kind: 'epa_dpa_dha', __typename: 'BiomarkerConfig' },
      {
        label: 'Omega 6/Omega 3 Ratio',
        unit: 'Ratio',
        kind: 'omega_6_omega_3_ratio',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Arachidonic Acid/EPA Ratio',
        unit: 'Ratio',
        kind: 'arachidonic_acid_epa_ratio',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Red Cell Distribution Width (RDW)',
        unit: '%',
        kind: 'rdw',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Platelet Count',
        unit: 'K/µL',
        kind: 'platelet_count',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Mean Corpuscular Hemoglobin Concentration (MCHC)',
        unit: 'g/dL',
        kind: 'mchc',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Mean Corpuscular Hemoglobin (MCH)',
        unit: 'pg',
        kind: 'mch',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Mean Corpuscular Volume',
        unit: 'fL',
        kind: 'mean_corpuscular_volume',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Hematocrit', unit: '%', kind: 'hematocrit', __typename: 'BiomarkerConfig' },
      { label: 'Hemoglobin', unit: 'g/dL', kind: 'hemoglobin', __typename: 'BiomarkerConfig' },
      {
        label: 'Mean Platelet Volume (MPV)',
        unit: 'fL',
        kind: 'mean_platelet_volume',
        __typename: 'BiomarkerConfig',
      },
      { label: 'WBC (Blood)', unit: 'K/µL', kind: 'wbc_blood', __typename: 'BiomarkerConfig' },
      { label: 'RBC (Blood)', unit: 'M/µL', kind: 'rbc_blood', __typename: 'BiomarkerConfig' },
      { label: 'Ferritin', unit: 'ng/mL', kind: 'ferritin', __typename: 'BiomarkerConfig' },
      {
        label: 'Lipoprotein (a)',
        unit: 'mg/dL',
        kind: 'lipoprotein_a',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Apolipoprotein A-1',
        unit: 'mg/dL',
        kind: 'apolipoprotein_a1',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Non-HDL Cholesterol',
        unit: 'mg/dL',
        kind: 'non_hdl_cholesterol',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Total Cholesterol / HDL Ratio',
        unit: 'Ratio',
        kind: 'total_cholesterol_hdl_ratio',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Zinc (RBC)', unit: 'mg/L', kind: 'zinc_rbc', __typename: 'BiomarkerConfig' },
      { label: 'Folate (RBC)', unit: 'ng/mL', kind: 'folate_rbc', __typename: 'BiomarkerConfig' },
      {
        label: 'Vitamin B12 (Cobalamin)',
        unit: 'pg/mL',
        kind: 'vitamin_b12',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Iron, Total', unit: 'mcg/dL', kind: 'iron_total', __typename: 'BiomarkerConfig' },
      {
        label: 'Total Iron Binding Capacity (TIBC)',
        unit: 'µg/dL',
        kind: 'tibc',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Iron % Saturation',
        unit: '%',
        kind: 'iron_percent_saturation',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Magnesium (RBC)',
        unit: 'mg/dL',
        kind: 'magnesium_rbc',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Free T4', unit: 'mIU/L', kind: 'free_t4', __typename: 'BiomarkerConfig' },
      {
        label: 'TPO Antibodies',
        unit: 'IU/mL',
        kind: 'tpo_antibodies',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Free T3', unit: 'mIU/L', kind: 'free_t3', __typename: 'BiomarkerConfig' },
      { label: 'Reverse T3', unit: 'ng/dL', kind: 'reverse_t3', __typename: 'BiomarkerConfig' },
      { label: 'Selenium', unit: 'µg/L', kind: 'selenium', __typename: 'BiomarkerConfig' },
      {
        label: 'LDL particle number',
        unit: 'nmol/L',
        kind: 'ldl_particle_number',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'LDL Pattern',
        unit: 'Pattern A/B',
        kind: 'ldl_pattern',
        __typename: 'BiomarkerConfig',
      },
      { label: 'LDL Small', unit: 'Low/none', kind: 'ldl_small', __typename: 'BiomarkerConfig' },
      { label: 'HDL Large', unit: 'Favorable', kind: 'hdl_large', __typename: 'BiomarkerConfig' },
      {
        label: 'Alanine Transferase (ALT)',
        unit: 'U/L',
        kind: 'alanine_transferase',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Albumin', unit: 'g/dL', kind: 'albumin', __typename: 'BiomarkerConfig' },
      {
        label: 'Alkaline Phosphatase',
        unit: 'U/L',
        kind: 'alkaline_phosphatase',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Methylmalonic Acid',
        unit: 'µmol/L',
        kind: 'methylmalonic_acid',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Blood Urea Nitrogen',
        unit: 'mg/dL',
        kind: 'blood_urea_nitrogen',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Creatinine', unit: 'mg/dL', kind: 'creatinine', __typename: 'BiomarkerConfig' },
      { label: 'Sodium', unit: 'mmol/L', kind: 'sodium', __typename: 'BiomarkerConfig' },
      { label: 'Potassium', unit: 'mmol/L', kind: 'potassium', __typename: 'BiomarkerConfig' },
      {
        label: 'BUN/Creatinine Ratio',
        unit: 'Ratio',
        kind: 'bun_creatinine_ratio',
        __typename: 'BiomarkerConfig',
      },
      {
        label: 'Estimated Glomerular Filtration Rate',
        unit: 'mL/min/1.73 m²',
        kind: 'estimated_gfr',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Amylase', unit: 'U/L', kind: 'amylase', __typename: 'BiomarkerConfig' },
      { label: 'Lipase', unit: 'U/L', kind: 'lipase', __typename: 'BiomarkerConfig' },
      { label: 'Chloride', unit: 'mmol/L', kind: 'chloride', __typename: 'BiomarkerConfig' },
      { label: 'Calcium', unit: 'mg/dL', kind: 'calcium', __typename: 'BiomarkerConfig' },
      {
        label: 'Carbon Dioxide',
        unit: 'mmol/L',
        kind: 'carbon_dioxide',
        __typename: 'BiomarkerConfig',
      },
      { label: 'Monocytes', unit: 'K/µL', kind: 'monocytes', __typename: 'BiomarkerConfig' },
      { label: 'Eosinophils', unit: 'K/µL', kind: 'eosinophils', __typename: 'BiomarkerConfig' },
      { label: 'Basophils', unit: 'K/µL', kind: 'basophils', __typename: 'BiomarkerConfig' },
      { label: 'Lymphocytes', unit: 'K/µL', kind: 'lymphocytes', __typename: 'BiomarkerConfig' },
      {
        label: 'Aspartate Transferase (AST)',
        unit: 'U/L',
        kind: 'aspartate_transferase',
        __typename: 'BiomarkerConfig',
      },
    ],
    researchFaqs: {
      gettingStartedUrl:
        'https://support.nutrisense.io/en_us/categories/getting-started-with-your-dexcom-cgm-S1G81901xl',
      __typename: 'ResearchFaqs',
    },
    insuranceKinds: {
      kindDefs: [
        { key: 'aetna', title: 'Aetna', __typename: 'UserInsurancePolicyKindDef' },
        { key: 'anthem', title: 'Anthem', __typename: 'UserInsurancePolicyKindDef' },
        {
          key: 'blue_cross_blue_shield',
          title: 'Blue Cross Blue Shield',
          __typename: 'UserInsurancePolicyKindDef',
        },
        { key: 'cigna', title: 'Cigna', __typename: 'UserInsurancePolicyKindDef' },
        { key: 'empire', title: 'Empire', __typename: 'UserInsurancePolicyKindDef' },
        { key: 'highmark', title: 'Highmark', __typename: 'UserInsurancePolicyKindDef' },
        { key: 'horizon', title: 'Horizon', __typename: 'UserInsurancePolicyKindDef' },
        { key: 'sana_benefits', title: 'Sana Benefits', __typename: 'UserInsurancePolicyKindDef' },
        {
          key: 'united_healthcare',
          title: 'United Healthcare',
          __typename: 'UserInsurancePolicyKindDef',
        },
      ],
      __typename: 'InsuranceKinds',
    },
    specialtyKinds: [
      { key: 'weight_concerns', name: 'Weight concerns', __typename: 'EhrCoachSpecialtyDef' },
      { key: 'eating_disorders', name: 'Eating disorders', __typename: 'EhrCoachSpecialtyDef' },
      {
        key: 'mindful_eating',
        name: 'Mindful/Intuitive eating',
        __typename: 'EhrCoachSpecialtyDef',
      },
      { key: 'gut_health', name: 'Gut health', __typename: 'EhrCoachSpecialtyDef' },
      {
        key: 'prediabetes_diabetes',
        name: 'Prediabetes & diabetes',
        __typename: 'EhrCoachSpecialtyDef',
      },
      {
        key: 'prenatal_nutrition',
        name: 'Prenatal/Postnatal nutrition',
        __typename: 'EhrCoachSpecialtyDef',
      },
      { key: 'fertility', name: 'Fertility', __typename: 'EhrCoachSpecialtyDef' },
      { key: 'womens_health', name: "Women's health", __typename: 'EhrCoachSpecialtyDef' },
      { key: 'mens_health', name: "Men's health", __typename: 'EhrCoachSpecialtyDef' },
      {
        key: 'sports_performance',
        name: 'Sports & performance',
        __typename: 'EhrCoachSpecialtyDef',
      },
      {
        key: 'autoimmune_conditions',
        name: 'Autoimmune conditions',
        __typename: 'EhrCoachSpecialtyDef',
      },
      {
        key: 'chronic_fatigue',
        name: 'Chronic fatigue/Low energy levels',
        __typename: 'EhrCoachSpecialtyDef',
      },
      {
        key: 'food_allergies',
        name: 'Food allergies & intolerances',
        __typename: 'EhrCoachSpecialtyDef',
      },
      { key: 'heart_disease', name: 'Heart disease', __typename: 'EhrCoachSpecialtyDef' },
      { key: 'cancer', name: 'Cancer', __typename: 'EhrCoachSpecialtyDef' },
      { key: 'bariatric', name: 'Bariatric', __typename: 'EhrCoachSpecialtyDef' },
      { key: 'thyroid_disorders', name: 'Thyroid disorders', __typename: 'EhrCoachSpecialtyDef' },
      { key: 'healthy_aging', name: 'Healthy aging', __typename: 'EhrCoachSpecialtyDef' },
      {
        key: 'health_optimization',
        name: 'Health optimization',
        __typename: 'EhrCoachSpecialtyDef',
      },
      { key: 'metabolic_health', name: 'Metabolic health', __typename: 'EhrCoachSpecialtyDef' },
      { key: 'hormonal_health', name: 'Hormonal health', __typename: 'EhrCoachSpecialtyDef' },
      {
        key: 'integrative_functional_nutrition',
        name: 'Integrative and functional nutrition',
        __typename: 'EhrCoachSpecialtyDef',
      },
      { key: 'stress_management', name: 'Stress Management', __typename: 'EhrCoachSpecialtyDef' },
      { key: 'osteoporosis', name: 'Osteoporosis', __typename: 'EhrCoachSpecialtyDef' },
      {
        key: 'kidney_stones',
        name: 'Kidney Stones/Metabolic Stone Disease',
        __typename: 'EhrCoachSpecialtyDef',
      },
    ],
    dexcomClientId: 's0VuXGmLS8znOjyfH2wyrslHuqfL4qwx',
    dexcomSteloClientId: 'eD0RMqq4Vvye9iJd350pndcij0EzFSqR',
    uhcDeepLinks: {
      storeUrl: 'https://member.uhc.com/uhc-store/subscriptions/',
      __typename: 'UhcDeepLinks',
    },
    labResults: { fileUploadLimitMb: 20, __typename: 'LabResultsConfig' },
    actionGoalOptions: [
      {
        kind: 'steps_goal',
        title: 'Step Count',
        category: 'fitness',
        icon: 'footprints',
        description: 'Walking or running steps taken',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'step_count_metric',
            statKey: 'step_count',
            trendSection: 'measurements',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Aim to reach a daily step count',
            infoText: null,
            metric: {
              units: 'steps',
              min: 2000.0,
              max: 20000.0,
              increment: 500.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'steps',
              min: 2000.0,
              max: 20000.0,
              increment: 500.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'flights_climbed_goal',
        title: 'Flights Climbed',
        category: 'fitness',
        icon: 'steps',
        description: 'Flights of stairs climbed',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'flights_climbed_metric',
            statKey: 'flights_climbed',
            trendSection: 'measurements',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Aim to climb a number of flights of stairs',
            infoText: null,
            metric: {
              units: 'flights',
              min: 5.0,
              max: 150.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'flights',
              min: 5.0,
              max: 150.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'running_distance_goal',
        title: 'Running Distance',
        category: 'fitness',
        icon: 'person_simple_run',
        description: 'Distance covered while running',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'running_distance_metric',
            statKey: 'running_distance',
            trendSection: 'measurements',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Aim to run a given distance',
            infoText: null,
            metric: { units: 'km', min: 0.5, max: 30.0, increment: 0.5, __typename: 'UnitOption' },
            imperial: {
              units: 'miles',
              min: 0.25,
              max: 20.0,
              increment: 0.25,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'cycling_distance_goal',
        title: 'Cycling Distance',
        category: 'fitness',
        icon: 'person_simple_bike',
        description: 'Distance covered while cycling',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'cycling_distance_metric',
            statKey: 'cycling_distance',
            trendSection: 'measurements',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Aim to cycle a given distance',
            infoText: null,
            metric: { units: 'km', min: 1.0, max: 80.0, increment: 1.0, __typename: 'UnitOption' },
            imperial: {
              units: 'miles',
              min: 1.0,
              max: 50.0,
              increment: 1.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'swimming_distance_goal',
        title: 'Swimming Distance',
        category: 'fitness',
        icon: 'person_simple_swim',
        description: 'Distance covered while swimming',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'swimming_distance_metric',
            statKey: 'swimming_distance',
            trendSection: 'measurements',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Aim to swim a given distance',
            infoText: null,
            metric: { units: 'km', min: 0.25, max: 5.0, increment: 0.25, __typename: 'UnitOption' },
            imperial: {
              units: 'miles',
              min: 0.1,
              max: 3.0,
              increment: 0.1,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'exercise_goal',
        title: 'Exercise',
        category: 'fitness',
        icon: 'person_simple_run',
        description: 'Time spent exercising',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'exercise_duration_gte_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of time exercising',
            infoText:
              'Only activities that start on the given date are considered towards completion.',
            metric: {
              units: 'minutes',
              min: 10.0,
              max: 180.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'minutes',
              min: 10.0,
              max: 180.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'exercise_presence_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: false,
            valuePrefix: null,
            description: 'Exercise for any amount of time',
            infoText:
              'Only activities that start on the given date are considered towards completion.',
            metric: null,
            imperial: null,
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'meditation_goal',
        title: 'Meditation',
        category: 'fitness',
        icon: 'flower_lotus',
        description: 'Time spent meditating',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'meditation_duration_gte_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of time meditating',
            infoText:
              'Only activities that start on the given date are considered towards completion.',
            metric: {
              units: 'minutes',
              min: 5.0,
              max: 120.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'minutes',
              min: 5.0,
              max: 120.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'meditation_presence_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: false,
            valuePrefix: null,
            description: 'Meditate for any amount of time',
            infoText:
              'Only activities that start on the given date are considered towards completion.',
            metric: null,
            imperial: null,
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'sleep_goal',
        title: 'Sleep',
        category: 'fitness',
        icon: 'bed',
        description: 'Time spent sleeping',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'sleep_duration_gte_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of time sleeping',
            infoText:
              "Sleep recorded after 6 PM is counted towards the next day's total sleep duration.",
            metric: {
              units: 'hours',
              min: 5.0,
              max: 12.0,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'hours',
              min: 5.0,
              max: 12.0,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'fiber_goal',
        title: 'Fiber Intake',
        category: 'nutrition',
        icon: 'carrot',
        description: 'Daily fiber consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'fiber_gte_metric',
            statKey: null,
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of fiber',
            infoText: null,
            metric: {
              units: 'grams',
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'carbs_goal',
        title: 'Carbohydrate Intake',
        category: 'nutrition',
        icon: 'fork_knife',
        description: 'Daily carbohydrate consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'carbs_gte_metric',
            statKey: 'carbs',
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of carbs',
            infoText: null,
            metric: {
              units: 'grams',
              min: 10.0,
              max: 750.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 10.0,
              max: 750.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'carbs_lte_metric',
            statKey: 'carbs',
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'At most this amount of carbs',
            infoText: 'Requires logging at least 1 meal per day to be eligible for completion.',
            metric: {
              units: 'grams',
              min: 10.0,
              max: 750.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 10.0,
              max: 750.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'protein_goal',
        title: 'Protein Intake',
        category: 'nutrition',
        icon: 'fish',
        description: 'Daily protein consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'protein_gte_metric',
            statKey: 'protein',
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of protein',
            infoText: null,
            metric: {
              units: 'grams',
              min: 10.0,
              max: 400.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 10.0,
              max: 400.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'calories_goal',
        title: 'Calorie Intake',
        category: 'nutrition',
        icon: 'food',
        description: 'Daily calorie consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'calories_gte_metric',
            statKey: 'calories',
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of calories',
            infoText: null,
            metric: {
              units: 'calories',
              min: 1000.0,
              max: 5000.0,
              increment: 50.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'calories',
              min: 1000.0,
              max: 5000.0,
              increment: 50.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'calories_lte_metric',
            statKey: 'calories',
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'At most this amount of calories',
            infoText: 'Requires logging at least 1 meal per day to be eligible for completion.',
            metric: {
              units: 'calories',
              min: 1000.0,
              max: 5000.0,
              increment: 50.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'calories',
              min: 1000.0,
              max: 5000.0,
              increment: 50.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'total_fat_goal',
        title: 'Total Fat Intake',
        category: 'nutrition',
        icon: 'fork_knife',
        description: 'Daily total fat consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'total_fat_gte_metric',
            statKey: 'fat',
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of total fat',
            infoText: null,
            metric: {
              units: 'grams',
              min: 10.0,
              max: 750.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 10.0,
              max: 750.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'total_fat_lte_metric',
            statKey: 'fat',
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'At most this amount of total fat',
            infoText: 'Requires logging at least 1 meal per day to be eligible for completion.',
            metric: {
              units: 'grams',
              min: 10.0,
              max: 750.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 10.0,
              max: 750.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'saturated_fat_goal',
        title: 'Saturated Fat Intake',
        category: 'nutrition',
        icon: 'fork_knife',
        description: 'Daily saturated fat consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'saturated_fat_lte_metric',
            statKey: null,
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'At most this amount of saturated fat',
            infoText: 'Requires logging at least 1 meal per day to be eligible for completion.',
            metric: {
              units: 'grams',
              min: 5.0,
              max: 70.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 5.0,
              max: 70.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'sugar_goal',
        title: 'Sugar Intake',
        category: 'nutrition',
        icon: 'cookie',
        description: 'Daily sugar consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'sugar_lte_metric',
            statKey: null,
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'At most this amount of sugar',
            infoText: 'Requires logging at least 1 meal per day to be eligible for completion.',
            metric: {
              units: 'grams',
              min: 0.0,
              max: 150.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 0.0,
              max: 150.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'sodium_goal',
        title: 'Sodium Intake',
        category: 'nutrition',
        icon: 'fork_knife',
        description: 'Daily sodium consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'sodium_lte_metric',
            statKey: null,
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'At most this amount of sodium',
            infoText: 'Requires logging at least 1 meal per day to be eligible for completion.',
            metric: {
              units: 'mg',
              min: 0.0,
              max: 4000.0,
              increment: 100.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg',
              min: 0.0,
              max: 4000.0,
              increment: 100.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'fasting_goal',
        title: 'Fasting',
        category: 'nutrition',
        icon: 'timer',
        description: 'Fasting duration',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'fasting_duration_gte_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'At least this amount of time fasting',
            infoText:
              'Only activities that start on the given date are considered towards completion.',
            metric: {
              units: 'minutes',
              min: 180.0,
              max: 1440.0,
              increment: 60.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'minutes',
              min: 180.0,
              max: 1440.0,
              increment: 60.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'fasting_presence_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: false,
            valuePrefix: null,
            description: 'Fast for any amount of time',
            infoText:
              'Only activities that start on the given date are considered towards completion.',
            metric: null,
            imperial: null,
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'net_carbs_goal',
        title: 'Net Carbohydrate Intake',
        category: 'nutrition',
        icon: 'fork_knife',
        description: 'Daily net carb consumption',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'net_carbs_lte_metric',
            statKey: null,
            trendSection: 'macros',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'At most this amount of net carbs',
            infoText:
              'Net carbs are calculated as total carbohydrates minus fiber. Requires logging at least 1 meal per day to be eligible for completion.',
            metric: {
              units: 'grams',
              min: 0.0,
              max: 420.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'grams',
              min: 0.0,
              max: 420.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_peak_goal',
        title: 'Glucose Max',
        category: 'glucose',
        icon: 'drop',
        description: 'Maximum glucose level',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_peak_score_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Achieve at least this glucose peak score',
            infoText: null,
            metric: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'glucose_max_stats_gte_metric',
            statKey: 'max',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Keep maximum glucose at or above this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 4.0,
              max: 13.5,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 70.0,
              max: 250.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'glucose_max_stats_lte_metric',
            statKey: 'max',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'Keep maximum glucose at or below this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 4.0,
              max: 13.5,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 70.0,
              max: 250.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_mean_goal',
        title: 'Glucose Average',
        category: 'glucose',
        icon: 'drop',
        description: 'Average glucose level',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_mean_score_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Achieve at least this glucose average score',
            infoText: null,
            metric: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_standard_deviation_goal',
        title: 'Glucose Variability',
        category: 'glucose',
        icon: 'drop',
        description: 'How glucose varies over time',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_standard_deviation_score_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Achieve at least this glucose variability score',
            infoText: null,
            metric: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'glucose_standard_deviation_stats_lte_metric',
            statKey: 'standard_deviation',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'Keep glucose variability (standard deviation) at or below this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 0.5,
              max: 5.0,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 10.0,
              max: 90.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_time_outside_range_goal',
        title: 'Glucose Adaptability',
        category: 'glucose',
        icon: 'drop',
        description: 'How quickly your glucose returns to normal after a spike',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_time_outside_range_score_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Achieve at least this glucose adaptability score',
            infoText: null,
            metric: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_total_score_goal',
        title: 'Glucose Total Score',
        category: 'glucose',
        icon: 'drop',
        description: 'Overall glucose score',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_total_score_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Achieve at least this overall glucose score',
            infoText: null,
            metric: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            imperial: {
              units: null,
              min: 10.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_time_in_range_goal',
        title: 'Glucose Time in Range',
        category: 'glucose',
        icon: 'drop',
        description: 'Time spent within target glucose range',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_time_in_range_stats_gte_metric',
            statKey: 'time_within_range',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Stay this percentage of time in your healthy glucose range',
            infoText: null,
            metric: { units: '%', min: 50.0, max: 100.0, increment: 5.0, __typename: 'UnitOption' },
            imperial: {
              units: '%',
              min: 50.0,
              max: 100.0,
              increment: 5.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_min_goal',
        title: 'Glucose Min',
        category: 'glucose',
        icon: 'drop',
        description: 'Minimum glucose level',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_min_stats_gte_metric',
            statKey: 'min',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Keep minimum glucose at or above this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 4.0,
              max: 13.5,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 70.0,
              max: 250.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'glucose_min_stats_lte_metric',
            statKey: 'min',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'Keep minimum glucose at or below this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 4.0,
              max: 13.5,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 70.0,
              max: 250.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_morning_average_goal',
        title: 'Glucose Morning Average',
        category: 'glucose',
        icon: 'drop',
        description: 'Average glucose level in the morning',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_morning_average_stats_gte_metric',
            statKey: 'morning_average',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Keep average morning glucose at or above this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 4.0,
              max: 13.5,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 70.0,
              max: 250.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'glucose_morning_average_stats_lte_metric',
            statKey: 'morning_average',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'Keep average morning glucose at or below this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 4.0,
              max: 13.5,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 70.0,
              max: 250.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'glucose_sleep_average_goal',
        title: 'Glucose Sleep Average',
        category: 'glucose',
        icon: 'drop',
        description: 'Average glucose level during sleep',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'glucose_sleep_average_stats_gte_metric',
            statKey: 'sleep_average',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At least',
            description: 'Keep average glucose during sleep at or above this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 4.0,
              max: 13.5,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 70.0,
              max: 250.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
          {
            kind: 'glucose_sleep_average_stats_lte_metric',
            statKey: 'sleep_average',
            trendSection: 'glucose',
            supportsMetricValue: true,
            valuePrefix: 'At most',
            description: 'Keep average glucose during sleep at or below this level',
            infoText: null,
            metric: {
              units: 'mmol/L',
              min: 4.0,
              max: 13.5,
              increment: 0.5,
              __typename: 'UnitOption',
            },
            imperial: {
              units: 'mg/dL',
              min: 70.0,
              max: 250.0,
              increment: 10.0,
              __typename: 'UnitOption',
            },
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'meal_presence_goal',
        title: 'Meal Presence',
        category: 'habits',
        icon: 'fork_knife',
        description: 'Log at least one meal',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'meal_presence_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: false,
            valuePrefix: 'At least',
            description: 'Log at least one meal',
            infoText: null,
            metric: null,
            imperial: null,
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
      {
        kind: 'video_call_presence_goal',
        title: 'Attend a Video Call',
        category: 'habits',
        icon: 'users',
        description: 'Complete a video call with your coach',
        requiresGoalText: false,
        allowsMultipleActiveGoalsForKind: false,
        metricOptions: [
          {
            kind: 'video_call_presence_metric',
            statKey: null,
            trendSection: null,
            supportsMetricValue: false,
            valuePrefix: 'At least',
            description: 'Complete a video call with your coach',
            infoText: null,
            metric: null,
            imperial: null,
            __typename: 'MetricOption',
          },
        ],
        __typename: 'ActionGoalOption',
      },
    ],
    coaches: { coachSwitchMaxSpecialtiesSelection: 3, __typename: 'CoachesConfig' },
    __typename: 'ClientConfig',
  },
}
